import { FolderTreeSelectNode } from "./types";

/** Убирает папку вместе с поддеревом: в неё саму и в её потомков папку не переложить. */
export function excludeFolderSubtree(
  nodes: FolderTreeSelectNode[],
  folderId: string,
): FolderTreeSelectNode[] {
  return nodes
    .filter((node) => node.value !== folderId)
    .map((node) =>
      node.children
        ? { ...node, children: excludeFolderSubtree(node.children, folderId) }
        : node,
    );
}
